export const session = {
  accessToken: '',
  autnMethod: '',
  availableBalance: '',
  beneficiaryAccount: '',
  beneficiaryBankName: '',
  beneficiaryName: '',
  beneficiarySortcode: '',
  brand: '',
  conversationId: '',
  currentBalance: '',
  customerSessionId: '',
  date: '',
  executiondate: '',
  executionId: '',
  isLoading: false,
  isSimSwapRequired: false,
  mandateCreationDate: '',
  mandateId: '',
  mandateNumber: '',
  oldPaymentReference: '', // TODO - Needs to be populated from Hub page.
  originatorAccount: '',
  originatorName: '',
  originatorSortcode: '',
  otpTimestamp: '',
  paymentAmount: '',
  paymentPurpose: '',
  reference: '',
  segment: '',
  simSwapResult: '',
  trusteerFlag: false,
  uid: '',
  when: '',
  balanceIncPending: '',
  overdraftRemaining: '',
  authorizedOverdraft: '',
  temporaryOverdraft: '',
  changeLinkClicked: false,
};
